'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBookOutline = function IoIosBookOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.2 5c4.3 0 7.8 2 7.8 6.2v22.1h-1.7c-1.3-2.4-3.5-3.3-6.1-3.3-3.1 0-5.8 2.2-6.4 5h-1.6c-0.6-2.8-3.3-5-6.4-5-2.6 0-5.1 1.3-6.1 3.3h-1.7v-22.1c0-4.2 3.5-6.2 7.8-6.2 3.2 0 6.1 1.1 7.2 3.4 0.9-2.3 4-3.4 7.2-3.4z m-7.8 27.1v-21c-0.1-3.4-3.1-4.9-6.6-4.9-3.4 0-6.3 1.5-6.6 4.8v20.6h0.1c1.5-2.1 3.8-2.9 6.5-2.9s5.2 1.4 6.6 3.4z m14.4-20.5v-1.2c-0.3-3.3-3.2-4.1-6.6-4.1-3.6 0-6.6 1.5-6.6 5v20.8c1.4-2 3.9-3.3 6.6-3.3s5.1 0.7 6.6 2.8v-20z' })
        )
    );
};

exports.default = IoIosBookOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-book-outline.js
// module id = 2087
// module chunks = 0